import LoginProcess from './lotties/login-process.json';
import LoginSupport from './lotties/login-support.json';
import LoginPayment from './lotties/login-payment.json';
import OderSuccess from './lotties/congratulation.json';
import Heart from './lotties/heart.json';
import RefferAndBound from './lotties/reffer-bonus.json';

export { LoginProcess, LoginSupport, LoginPayment, OderSuccess, Heart, RefferAndBound };
